import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "v2_chat_icon",
  "use": "v2_chat_icon-usage",
  "viewBox": "0 0 22 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 21\" id=\"v2_chat_icon\">\n    <path fill-rule=\"nonzero\" d=\"M5.526 3h10.948C17.869 3 19 4.06 19 5.368v7.106c0 1.308-1.131 2.368-2.526 2.368h-3.862L9.49 17.77a.868.868 0 0 1-.595.231c-.465 0-.842-.353-.842-.79v-2.368H5.526C4.131 14.842 3 13.782 3 12.474V5.368C3 4.06 4.131 3 5.526 3zm10.827 1H5.647C4.737 4 4 4.685 4 5.53v6.882c0 .844.737 1.53 1.647 1.53h3.294V17l3.294-3.059h4.118c.91 0 1.647-.685 1.647-1.53V5.53C18 4.685 17.263 4 16.353 4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol